import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';
import { useDispatch } from 'react-redux';

import { baseTheme } from '../../../theme';

import { approveGroupMemberAction, removeGroupMemberAction } from '../../../store';

interface GroupMemberListItemProps {
  member: object;
  group: object;
  color?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(0),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(0),

      '&:hover': {
        backgroundColor: theme.palette.text.disabled,
      },
    },
    alignTextCenter: {
      textAlign: 'center',
    },
    buttonSpacing: {
      width: '100%',
    },
  }),
);

export function GroupMemberListItem(props: any) {
  const { group, member, color = 'primary' } = props;
  const classes = useStyles(baseTheme);
  const dispatch = useDispatch();

  const handleMemberApprove = (member: any, groupId: string) => (event: any) => {
    event.stopPropagation();
    approveGroupMemberAction(groupId, member, dispatch);
  };

  const handleMemberRemove = (member: any, groupId: string) => (event: any) => {
    event.stopPropagation();
    removeGroupMemberAction(groupId, member, dispatch);
  };

  return (
    <Grid item container xs={12} spacing={2} className={classes.root}>
      <Grid item xs={10}>{member.name}</Grid>
      <Grid item xs={1} className={classes.alignTextCenter}>{
        member.status === 'unapproved'
          ? <Button
            variant="contained"
            color={color}
            className={classes.buttonSpacing}
            onClick={handleMemberApprove(member, group.id)}
          >
            Approve
          </Button>
          : member.joined
      }</Grid>
      <Grid item xs={1}>
        {
          member.type !== 'owner'
            ? <Button
              variant="contained"
              color={color}
              className={classes.buttonSpacing}
              onClick={handleMemberRemove(member, group.id)}
            >
              Remove
            </Button>
            : null
        }
      </Grid>
    </Grid>
  );
}
